import React from 'react';
import { FormControl, FormControlLabel, Checkbox as MuiCheckbox, FormHelperText } from '@material-ui/core';

export default function Checkbox(props) {
  const { name, label, value, onChange, disabled = false, error, ...other } = props;
  const convertToDefEventPara = (name, value) => ({
    target: {
      name,
      value,
    },
  });
  return (
    <FormControl>
      <FormControlLabel
        control={
          <MuiCheckbox
            name={name}
            color="primary"
            checked={value}
            disabled={disabled}
            {...other}
            onChange={(e) => onChange(convertToDefEventPara(name, e.target.checked))}
          />
        }
        label={label}
      />
      {error && <FormHelperText error={!!error}>{error}</FormHelperText>}
    </FormControl>
  );
}
